import { statusLabel, DEFAULT_STATUS, STATUS_COLORS, STATUS_VALUES } from "@/constants/workflow";

/**
 * Status legend for the active colour mode. Mirrors the status filter: when a
 * status is selected for that department only that entry is listed, otherwise
 * every status present in the loaded panels is shown.
 */
export function StatusLegend({ department, panels, selectedStatus, onPick }) {
  const counts = new Map();
  panels.forEach((panel) => {
    const value = panel.statuses?.[department] ?? null;
    // Panels without a stored logistics value fall back to the department default.
    const key = value == null || value === "" ? DEFAULT_STATUS[department] || "__null__" : value;
    counts.set(key, (counts.get(key) || 0) + 1);
  });

  const all = STATUS_VALUES[department] || [];
  const keys = selectedStatus
    ? [selectedStatus]
    : all.filter((key) => counts.get(key));

  if (!keys.length) return null;

  return (
    <div
      data-testid="status-legend"
      className="pointer-events-auto absolute bottom-12 left-4 z-20 w-56 rounded-xl border border-slate-300 bg-white/95 p-3 shadow-xl backdrop-blur-md lg:left-[15.5rem]"
    >
      <p className="mono mb-2 border-b border-slate-200 pb-2 text-[10px] uppercase tracking-[0.18em] text-cyan-700">
        {department === "qaqc" ? "QA/QC" : department} status
        {selectedStatus ? " · filtered" : ""}
      </p>
      <div className="space-y-0.5">
        {keys.map((key) => (
          <button
            key={key}
            data-testid={`status-legend-${key}`}
            onClick={() => onPick?.(key)}
            className="flex w-full items-center gap-2 rounded px-1.5 py-1 text-left text-[11px] hover:bg-slate-100"
          >
            <span
              className="h-2.5 w-2.5 shrink-0 rounded-sm"
              style={{ backgroundColor: STATUS_COLORS[department]?.[key] || "#64748B" }}
            />
            <span className="truncate text-slate-700">
              {key === "__null__" ? statusLabel(null) : key}
            </span>
            <span className="mono ml-auto text-slate-500">{counts.get(key) || 0}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
